<template>
    <div class="childpage-box">
    </div>
</template>
<script>
export default {
    data() {
      return {
        fullscreenLoading: false
      }
    },
    created(){
        
    },
    mounted(){
        this.openFullScreen();
    },
    methods:{
         openFullScreen() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, .3)',
                target:'.childpage-box',
            });
            setTimeout(() => {
                loading.close();
            }, 2000);
      },
    }
}
</script>
<style scoped>
    .childpage-box{
        padding-left: 150px;
        height: 100px;
    }
</style>


